export const actionTypes = {
    SUBMIT_FEEDBACK_START: 'SUBMIT_FEEDBACK_START',
    SUBMIT_FEEDBACK_SUCCESS: 'SUBMIT_FEEDBACK_SUCCESS',
    SUBMIT_FEEDBACK_FAILED: 'SUBMIT_FEEDBACK_FAILED',
    SUBMIT_FEEDBACK_COMPLETED: 'SUBMIT_FEEDBACK_COMPLETED'
};